"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var main_1 = require("../../themes/main");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        sectionHeader: {
            position: 'relative',
            backgroundColor: "".concat(main_1.materialColors.grey[100]),
            padding: "".concat(theme.spacing(0.75), "px ").concat(theme.spacing(1), "px"),
            fontWeight: 700,
            borderRight: '1px solid #ECEBEA',
            height: 30,
        },
        sectionCell: {
            height: 45,
            padding: "".concat(theme.spacing(1.5), "px ").concat(theme.spacing(1), "px"),
            borderBottom: '1px solid #ECEBEA',
            borderRight: '1px solid #ECEBEA',
        },
    });
});
